module.exports = __webpack_public_path__ + "static/media/Dayly_ios_2.e4b8d14f.jpg";